// shared-types/src/accountPaymentMethod/types.ts

import { Account } from "../account";
import { AccountIntegration } from "../accountIntegration";
import { Currency } from "../common/Currency";
import { StatusInfo } from "../common/Status";
import { EffectiveExchangeRate } from "../accountExchangeRate/types";

export enum AccountPaymentMethodStatus {
  ACTIVE = 'ACTIVE', // Active
  INACTIVE = 'INACTIVE', // Disabled
}

export interface AccountPaymentMethod {
  id: string;
  accountId: string;
  accountIntegrationId?: string;
  name: string;
  description?: string;
  customerInstructions?: string;
  order: number;
  availableForWeb?: boolean;
  
  status: AccountPaymentMethodStatus;
  demo: boolean;
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date;

  accountIntegration?: AccountIntegration;
  account?: Account;
  statusInfo?: StatusInfo;
  typeName?: string;
  /** Currency the gateway will charge in (API-resolved; do not infer from provider in UI). */
  chargeCurrency?: Currency;
  /** Present when account store currency differs from chargeCurrency and a rate exists. */
  exchangeRate?: EffectiveExchangeRate;
}